var render, staticRenderFns
import script from "./DealerBalance.vue?vue&type=script&lang=js"
export * from "./DealerBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f42ea4d6')) {
      api.createRecord('f42ea4d6', component.options)
    } else {
      api.reload('f42ea4d6', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_balance/DealerBalance.vue"
export default component.exports